module.exports = __webpack_public_path__ + "static/media/shopmonkey.12ae51d5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/shopmonkey.webp
// module id = 595
// module chunks = 0